export type CountryCode = "AU" | "US" | "GB" | "IN" | "NZ";
export type CurrencyCode = "AUD" | "USD" | "GBP" | "INR" | "NZD";
export type CurrencySymbol = "$" | "£" | "₹";
export type DiallingCode = "+61" | "+1" | "+44" | "+91" | "+64";

export type AreaCode = {
  area: string;
  code: string;
};

export type Country = {
  code: CountryCode;
  name: string;
  timezones: string[];
  currencyCode: CurrencyCode;
  currencySymbol: CurrencySymbol;
  diallingCode: DiallingCode;
  areaCodes?: AreaCode[];
};

const NZ: Country = {
  code: "NZ",
  name: "New Zealand",
  timezones: ["Pacific/Auckland", "Pacific/Chatham"],
  currencyCode: "NZD",
  currencySymbol: "$",
  diallingCode: "+64",
};

const AU: Country = {
  code: "AU",
  name: "Australia",
  timezones: [
    "Australia/Sydney",
    "Australia/Hobart",
    "Australia/Melbourne",
    "Australia/Brisbane",
    "Australia/Adelaide",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Perth",
  ],
  currencyCode: "AUD",
  currencySymbol: "$",
  diallingCode: "+61",
  /**
   * Reference: https://www.australia.gov.au/telephone-country-and-area-codes
   */
  areaCodes: [
    { area: "New South Wales", code: "02" },
    { area: "Australian Capital Territory", code: "02" },
    { area: "Victoria", code: "03" },
    { area: "Tasmania", code: "03" },
    { area: "Queensland", code: "07" },
    { area: "Western Australia", code: "08" },
    { area: "South Australia", code: "08" },
    { area: "Northern Territory", code: "08" },
  ],
};

const IN: Country = {
  code: "IN",
  name: "India",
  timezones: ["Asia/Kolkata"],
  currencyCode: "INR",
  currencySymbol: "₹",
  diallingCode: "+91",
};

const US: Country = {
  code: "US",
  name: "United States",
  currencyCode: "USD",
  currencySymbol: "$",
  timezones: [
    "America/New_York",
    "America/Detroit",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Indiana/Indianapolis",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Vevay",
    "America/Chicago",
    "America/Indiana/Tell_City",
    "America/Indiana/Knox",
    "America/Menominee",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/North_Dakota/Beulah",
    "America/Denver",
    "America/Boise",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Juneau",
    "America/Sitka",
    "America/Metlakatla",
    "America/Yakutat",
    "America/Nome",
    "America/Adak",
    "Pacific/Honolulu",
  ],
  diallingCode: "+1",
};

const GB: Country = {
  code: "GB",
  name: "United Kingdom",
  timezones: ["Europe/London"],
  currencyCode: "GBP",
  currencySymbol: "£",
  diallingCode: "+44",
};

const countryMap = { AU, US, GB, NZ, IN };
const countryList: Country[] = Object.values(countryMap);
const countryCodes: CountryCode[] = Object.values(countryMap).map((country) => country.code);

const getCountryForCode = (code?: CountryCode) => {
  if (!code) return;
  return countryList.find((country) => country.code === code);
};

export const country = {
  codes: countryCodes,
  map: countryMap,
  getForCode: getCountryForCode,
  IN,
  AU,
  GB,
  US,
  NZ,
};
